<script>
  import store from './../../store/index.js';
  const { VUE_APP_API_HOST } = process.env
  let simulateInProgress = false;

  const defaultBot = {
    id: null,
    name: '',
    page: 0,
    topics: {
      theme: null,
      category: null,
      lang: 'fr'
    },
    hashtag: '',
    hashtagPrefix: '',
    inclusion: {
      tag: '',
      tags: []
    },
    exclusion: {
      tag: '',
      tags: []
    },
    blacklists: {
      tag: '',
      tags: []
    },
    sources: [],
    posts: {
      content: ['photo', 'video'],
      display: 'title',
      display_instagram: null,
      mode: 'standard',
      linkInComments: false,
      mixAutoPost: 0 
    },
    frequency: {
      custom: false,
      value: 60
    },
    utm: '',
    limit: 1,
    planning: {
      monday: null,
      tuesday: null,
      wednesday: null,
      thursday: null,
      friday: null,
      saturday: null,
      sunday: null
    },
    //sourceType: 'normal',
    sourceType: 'custom',
    whitelist: [],
    mentions: [],
    hashtagsAuto: [],
    instagram: {
      credentials: {
        username: null,
        password: null
      },
      layout: null
    },
    afterAutoPost : {
      retweetAuto: [],
      reshareAuto: [],
      repostAuto: []
    }
  }

  // eslint-disable-next-line
  const conversionTable = Object.freeze({
    // TODO
    // Local repr -> server repr
    id: 'id',
    name: 'name',
    page: 'page',
    'topics.theme.url': 'domain',
    'topics.category': 'category',
    'topics.lang': 'locale',
    hashtag: 'hashtag',
    blacklists: { // ?
      tag: '',
      tags: []
    },
    sources: [],
    posts: {
      content: ['photo', 'video'],
      display: 'title'
    },
    frequency: {
      custom: false,
      value: 60
    },
    utm: 'utm_source',
    limit: 'capping',
    status: 1
  })

  export default {
    data() {
      return { 
        defaultBot: { ...defaultBot },
      }
    },

    methods: {
      /**
       * Convert bot from LOCAL format to SERVER format.
       * @param {Object} bot - The bot at the LOCAL format
       * @returns {Object} - The bot at the SERVER format
       */
      // eslint-disable-next-line
      encode(bot) {
        // eslint-disable-next-line
        const serverBot = {}
      },

      /**
       * Convert bot from SERVER format to LOCAL format.
       * @param {Object} bot - The bot at the SERVER format
       * @return {Object} - The bot at the SERVER format
       */
      // eslint-disable-next-line
      decode(bot) {
        // eslint-disable-next-line
        const localBot = {}
      },

      searchSubCategories(theme, language) {
        return `${VUE_APP_API_HOST}/categories/search?type=${theme}&language=${language}&query=`
      },

      services(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/services`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      create(body) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/bots/`, body, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      createBot(body) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/bots/`, body, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      modify(bot) {
        return this.$http
                   .put(`${VUE_APP_API_HOST}/bots/${bot.id}`, bot, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      modifyBot(bot) {
        return this.$http
                   .put(`${VUE_APP_API_HOST}/bots/${bot.id}`, bot, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      get(body) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     },
                     { body }
                   )
                   .then(res => res, err => err)
      },
      getAllBots(body, minify=false) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots${minify ? '?minify=true' : ''}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     },
                     { body }
                   )
                   .then(res => res, err => err)
      },

      del(id) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/bots/${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      deleteBot(id) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/bots/${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getSlotsByBot(id) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/bots/${id}/slot`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      deleteSlotByBot(id, date) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/bots/${id}/slot?date=${date}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      openMentionSimulate(id) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots/openmention?id=${id}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
      },


      getMentionsByApi(id, search, isUrl) {
        if (simulateInProgress) {
          console.log("Simulate in progress");
          return;
        }
        search = encodeURIComponent(search)
        let needSimulate = false;
        let simulate = localStorage.simulateInstagram;
        console.log("Simulate", simulate);
        let currentPageId = id;
        if (!simulate) {
          needSimulate = true;
          localStorage.setItem('simulateInstagram', JSON.stringify({[currentPageId]: Date.now()}))
        } else {
          simulate = JSON.parse(simulate)
          let currentSimulate = simulate[currentPageId];
          if (!currentSimulate ||  Math.floor(Math.abs(Date.now() - currentSimulate) / (1000 * 60)) > 120) {
            needSimulate = true;
            simulate[currentPageId] = Date.now();
            localStorage.setItem('simulateInstagram', JSON.stringify(simulate))
          }
        }
        console.log("needSimulate",needSimulate);
          

        // const currentTime = Date.now();
        // search = encodeURIComponent(search)
        // if(needSimulate || !this.$store.getters['postCreator/historySimulateResquest'][id] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][id] > 600000) needSimulate = true
        simulateInProgress = needSimulate;

        return this.$http.get(
                     `${VUE_APP_API_HOST}/bots/mentions?id=${id}&search=${search}&url=${isUrl}&simulate=${needSimulate}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   ).then(res => {simulateInProgress = false; return res}, err => {simulateInProgress = false; return err})
      },

      getAvatarMentionByApi(id, mention) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots/mentions/avatar?id=${id}&mention=${mention}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
      },

      getHashtagsByApi(id, search) {
        if (simulateInProgress) {
          console.log("Simulate in progress");
          return;
        }
        let needSimulate = false;
        let simulate = localStorage.simulateInstagram;
        console.log("Simulate", simulate);
        let currentPageId = id;
        if (!simulate) {
          needSimulate = true;
          localStorage.setItem('simulateInstagram', JSON.stringify({[currentPageId]: Date.now()}))
        } else {
          simulate = JSON.parse(simulate)
          let currentSimulate = simulate[currentPageId];
          if (!currentSimulate ||  Math.floor(Math.abs(Date.now() - currentSimulate) / (1000 * 60)) > 120) {
            needSimulate = true;
            simulate[currentPageId] = Date.now();
            localStorage.setItem('simulateInstagram', JSON.stringify(simulate))
          }
        }
        console.log("needSimulate",needSimulate);
        simulateInProgress = needSimulate;

        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots/hashtags?id=${id}&search=${search}&simulate=${needSimulate}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => {simulateInProgress = false; return res}, err => {simulateInProgress = false; return err})
      },

      getHighlightsInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/highlight`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      getUsernameInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/username`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },
      getAvatarInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/avatar`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      getInfoInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/information`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      twoFactorInstagramConnect(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/administration/proxies/connectapi`, params,
                     {
                      
                     },
                   )
                   .then(res => res, err => err)
      },

      twoFactorLinkedinConnect(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/bots/challenge/directapi`, params,
                     {
                      
                     },
                   )
                   .then(res => res, err => err)
      },

      connectLinkedinDirect(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/bots/connect/directapi`, params,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                     },
                   )
                   .then(res => res, err => err)
      },
    }
  }
</script>
